import { useRouteMatch } from 'react-router-dom';
import { DrawerRoute } from 'components/drawer-route';
import { AddManualBidderDrawer } from 'components/pages/campaign-settings/campaign-auction/auction-bidders/AddManualBidderDrawer';
import { EditBidderDrawer } from 'components/pages/campaign-settings/campaign-auction/auction-bidders/EditBidderDrawer';
import { BiddersIndex } from 'components/pages/campaign-settings/campaign-auction/bidders-index';
import { Route } from 'components/router/Route';
import { useFlags } from 'launchdarkly-react-client-sdk';

const BiddersRouter = () => {
    const match = useRouteMatch();
    const { auctionsCreateBidder = false, auctionsManageBidder = false } = useFlags();

    return (
        <>
            {auctionsManageBidder && (
                <DrawerRoute path={`${match.path}/:bidderId/edit`} component={EditBidderDrawer} />
            )}
            {auctionsCreateBidder && (
                <DrawerRoute path={`${match.path}/create`} component={AddManualBidderDrawer} />
            )}
            <Route path={match.path} component={BiddersIndex} />
        </>
    );
};

export { BiddersRouter };
